import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NotificationService } from '../../services';

@Component({
  selector: 'rappider-json-input',
  templateUrl: './json-input.component.html',
  styleUrls: ['./json-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => RappiderJsonInputComponent),
      multi: true
    }
  ]
})
export class RappiderJsonInputComponent implements ControlValueAccessor {

  @Input() editorOptions: any = {
    theme: 'vs-default',
    language: 'json',
    minimap: { autohide: true, enabled: false },
    lineNumbers: { renderType: 0 }
  };

  @Output() blur = new EventEmitter<any>();

  _value: any;
  localeValue: string;

  constructor(
    private notificationService: NotificationService
  ) { }

  get value() {
    return this._value;
  }

  set value(value: any) {
    this._value = value;
    this.localeValue = JSON.stringify(this.value);
    this.onChange(value);
    this.onTouched();
    this.blur.emit(value);
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(value: Record<string, any>): void {
    if (value) {
      this._value = value;
      this.localeValue = JSON.stringify(this.value);
    } else {
      this._value = null;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onCodemirrorValueChange(value) {
    this.localeValue = value;
  }


  onCodemirrorSave() {
    try {
      this.value = JSON.parse(this.localeValue);
      this.notificationService.createNotification(
        'success',
        'SHARED.SUCCESSFUL',
        'Json Saved Successfully'
      );
    } catch (error) {
      this.notificationService.createNotification(
        'error',
        'SHARED.ERROR',
        `${error}`
      );
    }
  }

}
